import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "MyContacts";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
    name,
    initialState,
    extraReducers: (builder) => {
        createExtraReducers(builder, extraActions);
    },
});

// exports

export const MyContactsActions = { ...slice.actions, ...extraActions };
export const MyContactsReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        LoadInmateMyContactsDisplayDetails: [],
        InmateFreeCreditBalanceResultDetails: [],
        LoadInmateCactasTransactionHistoryDetails: [],
        UpdateInmateConnectionDetails: [],
    };
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;


    return {
        LoadInmateMyContactsDisplay: LoadInmateMyContactsDisplay(),
        InmateFreeCreditBalanceResult: InmateFreeCreditBalanceResult(),
        loadLoadInmateCactasTransactionHistory: loadLoadInmateCactasTransactionHistory(),
        loadUpdateInmateConnection: loadUpdateInmateConnection(),
        loadValidateSendMailToPublicUser : ValidateSendMailToPublicUser()
    };

       function ValidateSendMailToPublicUser() {
        return createAsyncThunk(
            `${name}/ValidateSendMailToPublicUser`,
            async ({userId, PublicUserName, PublicUserEmail, InmatesFullName, FacilityID}) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/MyContact/ValidateSendMailToPublicUser?userID=${userId}&PublicUserName=${PublicUserName}&PublicUserEmail=${PublicUserEmail}&InmatesFullName=${InmatesFullName}&FacilityID=${FacilityID}`)
        );
    }

    function loadUpdateInmateConnection() {
        return createAsyncThunk(
            `${name}/loadUpdateInmateConnection`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/MyContact/UpdateInmateConnection`, objData)
        );
    }

    function LoadInmateMyContactsDisplay() {
        return createAsyncThunk(
            `${name}/LoadInmateMyContactsDisplay`,
            async ({ inmatesId, userID, connectionStatus }) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/MyContact/LoadInmateMyContactsDisplay?inmatesId=${inmatesId}&sortField=${"PUIConnectionID DESC"}&userID=${userID}&connectionStatus=${connectionStatus}`)
        );
    }

    function InmateFreeCreditBalanceResult() {
        return createAsyncThunk(
            `${name}/InmateFreeCreditBalanceResult`,
            async (loginResponse) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/MyContact/InmateFreeCreditBalanceResult?inmateResidentID=${loginResponse?.InmatesResdId}&facilityID=${loginResponse?.facilityID}`)
        );
    }
    function loadLoadInmateCactasTransactionHistory() {
        return createAsyncThunk(
            `${name}/loadLoadInmateCactasTransactionHistory`,
            async (loginResponse) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/MyContact/LoadInmateCactasTransactionHistory?facilityID=${loginResponse?.facilityID}&inmatesId=${loginResponse?.InmateID}`)
        );
    }

}

function createExtraReducers(builder, actions) {
    builder
        .addCase(actions.LoadInmateMyContactsDisplay.pending, (state) => {
            state.LoadInmateMyContactsDisplayDetails = [];
        })
        .addCase(actions.LoadInmateMyContactsDisplay.fulfilled, (state, action) => {
            state.LoadInmateMyContactsDisplayDetails = action.payload;
        })
        .addCase(actions.LoadInmateMyContactsDisplay.rejected, (state, action) => {
            state.LoadInmateMyContactsDisplayDetails = { error: action.error };
        })
        .addCase(actions.InmateFreeCreditBalanceResult.pending, (state) => {
            state.InmateFreeCreditBalanceResultDetails = [];
        })
        .addCase(actions.InmateFreeCreditBalanceResult.fulfilled, (state, action) => {
            state.InmateFreeCreditBalanceResultDetails = action.payload;
        })
        .addCase(actions.InmateFreeCreditBalanceResult.rejected, (state, action) => {
            state.InmateFreeCreditBalanceResultDetails = { error: action.error };
        })
        .addCase(actions.loadLoadInmateCactasTransactionHistory.pending, (state) => {
            state.LoadInmateCactasTransactionHistoryDetails = [];
        })
        .addCase(actions.loadLoadInmateCactasTransactionHistory.fulfilled, (state, action) => {
            state.LoadInmateCactasTransactionHistoryDetails = action.payload;
        })
        .addCase(actions.loadLoadInmateCactasTransactionHistory.rejected, (state, action) => {
            state.LoadInmateCactasTransactionHistoryDetails = { error: action.error };
        })
        .addCase(actions.loadUpdateInmateConnection.pending, (state) => {
            state.UpdateInmateConnectionDetails = [];
        })
        .addCase(actions.loadUpdateInmateConnection.fulfilled, (state, action) => {
            state.UpdateInmateConnectionDetails = action.payload;
        })
        .addCase(actions.loadUpdateInmateConnection.rejected, (state, action) => {
            state.UpdateInmateConnectionDetails = { error: action.error };
        });
}
